export default __webpack_public_path__ + "static/media/icon-32-icn-pickdown.2ea4928a.svg";